import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'connected-react-router'
import { trackEvent } from '@offerzen/pinata'
import { useFetchCandidateProfile, useMutateCandidateProfile } from '../../hooks/useCandidateProfile'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'

const CitizenshipStatusContainer = ({ children, reduxUpdateProgress, candidate, reduxChangeUrl, history, location }) => {
  useEffect(() => {
    reduxUpdateProgress(48)
    if (candidate) {
      trackEvent('onboarding-citizenship-status-accessed')
    }
  }, [reduxUpdateProgress, candidate])

  const {
    candidateProfile = { regionalCitizenships: [] },
    isLoading: isLoadingCandidates,
    error: candidateProfileError,
  } = useFetchCandidateProfile({
    enabled: !!candidate,
    candidateId: candidate && candidate.id,
  })

  const mutation = useMutateCandidateProfile(candidate && candidate.id)

  const updateCitizenshipStatus = formData => {
    return Promise.all(
      formData.map(data =>
        mutation.mutateAsync({
          input: { id: data.id, citizenshipStatus: data.citizenshipStatus },
        }),
      ),
    )
  }

  let preferredCountries = []

  if (candidateProfile.preferredCities) {
    preferredCountries = candidateProfile.preferredCities.map(preferredCity => preferredCity.countryName)
  }
  const uniqueCountries = preferredCountries
    .filter((country, index, preferredCountriesArray) => !!country && preferredCountriesArray.indexOf(country) === index)
    .sort()

  return children({
    countryBasedCitizenships: candidateProfile.regionalCitizenships,
    preferredCountries: uniqueCountries,
    isLoadingCandidates,
    candidateProfileError,
    updateCitizenshipStatus,
    reduxChangeUrl,
    history,
    location,
    candidateId: candidate && candidate.id,
  })
}

CitizenshipStatusContainer.propTypes = {
  reduxUpdateProgress: PropTypes.func.isRequired,
  candidate: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
}

const mapStateToProps = state => ({
  candidate: state.candidate,
})

const mapDispatchToProps = {
  reduxUpdateProgress: reduxUpdateProgress,
  reduxChangeUrl: push,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CitizenshipStatusContainer))
